var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadimagegray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42005_43716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42005_43716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 13.3335V6.54183L6.99967 8.7085L5.83301 7.50016L9.99967 3.3335L14.1663 7.50016L12.9997 8.7085L10.833 6.54183V13.3335H9.16634ZM4.99967 16.6668C4.54134 16.6668 4.14898 16.5036 3.82259 16.1772C3.4962 15.8509 3.33301 15.4585 3.33301 15.0002V12.5002H4.99967V15.0002H14.9997V12.5002H16.6663V15.0002C16.6663 15.4585 16.5031 15.8509 16.1768 16.1772C15.8504 16.5036 15.458 16.6668 14.9997 16.6668H4.99967Z",
    fill: "#6B7280"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimagegray);
export default __webpack_public_path__ + "static/media/uploadimagegray.69eb1c31a077f49f13f9b37e39480462.svg";
export { ForwardRef as ReactComponent };